import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { Icon, Tooltip } from 'antd';
import { withTranslation } from 'react-i18next';
import { SidebarMenuWrapper, SettingsCloseButton } from '../ComplexDocumentDesign/styles';
import { Logo, AppLogo, MenuTabs, TabsContainer, TabDetails, TabIcon, SideBarContent, SidebarCloseMenu,
  TabsActivityContainer, TabsActivityHighlighter, TabExpandContainer, TabMenuContainer } from '../SidebarMenu/styles';
import ExitIcon from '../../images/exit.svg';
import { DocStudioLogo } from '../../components/SidebarMenuIcons';
import EditorElement from '../../components/EditorElement';
import LetsDesignTabDetails from './LetsDesignTabDetails';
import UploadsTabDetails from '../SidebarMenu/UploadsTabdetails';
import CreativeElementsTabDetails from '../ComplexDocumentDesign/CreativeElementsTabDetails';
import EmailTemplateName from './EmailTemplateName';
import { CreativeDesignTabs } from '../ComplexDocumentDesign/sidebarTabs';
import { ComplexDesignTabs } from './sidebarTabs';
import { useArtboardContext, CONTEXT_KEYS , TEMPLATE_TYPE} from '../../context/complexArtboardContext';
import { useDocumentContext , COMPLEX_DOCUMENT_CONTEXT_KEYS} from '../../context/complexDocumentContext';
import { useEmailContext, COMPLEX_EMAIL_CONTEXT_KEYS } from '../../context/complexEmailContext';
import ComplexEmailVariablesTab from './ComplexEmailVariablesTab';
import ComplexEmailSettingsTab from './ComplexEmailSettingsTab';
import ComplexEmailMetaTab from './ComplexEmailMetaTab';
import ComplexEmailTemplatesTab from './ComplexEmailTemplatesTab';
import ComplexEmailElementsTab from './ComplexEmailElementsTab';
import ComplexEmailFolderTab from '../ComplexDocumentDesign/ComplexEmailFolderTab';
import MasterElementsTabDetails from '../SidebarMenu/MasterElementsTabDetails';
import { DESIGN_AREA_SIDEBAR_MENUS } from '../SidebarMenu/translationValues';
import { dummyCallback } from '../../utils/complexDocumentConstants';
import BusinessLogicTab from '../ComplexDocumentDesign/BusinessLogicTab';
import ComplexEmailTranslateTab from './ComplexEmailTranslateTab';
import ChannelTab from '../ComplexDocumentDesign/ChannelTab/CommunicationTab';
import { useSessionContext } from '../../context/sessionContext';
import { checkUserAccessRoles } from '../../utils/helper';
import ComplexDocumentAccessibilityValidator from '../ComplexDocumentDesign/ComplexDocumentAccessibilityValidator';

const DEFAULT_TAB_INDEX = 2;
const DEFAULT_CREATIVE_TAB_INDEX = 6;

const NAMESPACES = ['COMPLEX_DOC_SIDEBAR', 'DESIGN_AREA_SIDEBAR_MENUS' , "COMPLEX_DOC_LOGO_HEADER"];
const ComplexEmailSidebar = ({ t }) => {
  const [{ currentPageUUID, hideSideBar, isCreativeDesign, currentBlock, editable }, updateArtboard] = useArtboardContext(store => ({
    currentPageUUID: store[CONTEXT_KEYS.CURRENT_PAGE],
    hideSideBar: store[CONTEXT_KEYS.PAGE_LAYOUT_VISIBLE] || store[CONTEXT_KEYS.ELEMENT_SETTINGS_VISIBLE] || store[CONTEXT_KEYS.BLOCK_SETTINGS_VISIBLE],
    isCreativeDesign: store[CONTEXT_KEYS.SWITCH_CREATIVE_DESIGN_MENU],
    currentBlock: store[CONTEXT_KEYS.CURRENT_BLOCK],
    editable: store[CONTEXT_KEYS.ENABLE_EDITABLE_DESIGN]
  }), 'ComplexEmailSidebar');

  const customSelector = useCallback(store => {
    if (currentBlock && currentBlock !== '' && currentPageUUID && currentPageUUID !== '') {
      const pageWidth = store[currentPageUUID]?.width;
      const pageHeight = store[currentPageUUID]?.height;
      const size = {
        widthInPX: pageWidth,
        heightInPX: pageHeight
      };
      return {
        size
      };
    }
    return {};
  }, [currentBlock, currentPageUUID]);
  const [pageSettings, methods] = useDocumentContext(customSelector, 'ComlpexArtboardSidebar');

  const [,emailMethods] = useEmailContext(dummyCallback, 'ComlpexArtboardSidebar');
  const [isHtmlExpanded, setIsHtmlExpanded] = useState(false);
  const [ tabIndex, setTabIndex ] = useState(DEFAULT_TAB_INDEX);
  const [ activeTabPosY, setActiveTabPosY ] = useState('');
  const scrollRef = useRef(undefined);

  const getCurrentDesign = useCallback(store => store[CONTEXT_KEYS.CURRENT_DESIGN], []);
  const [CurrentDesign] = useArtboardContext(getCurrentDesign);

  const previewDownloadSelector = useCallback(store => store[CONTEXT_KEYS.PREVIEW_AND_DOWNLOAD], []);
  const [previewDownloadTab] = useArtboardContext(previewDownloadSelector);

  const  blockTypeSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.REUSABLE_BLOCK_TYPE], []);
  const [reusableBlockType] = useDocumentContext(blockTypeSelector, `ComplexEmailSidebar`);

  const  documentIdSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.ID], []);
  const [documentId] = useDocumentContext(documentIdSelector, `ComplexEmailSidebar`);
  const subjectSelector = useCallback(store => store[COMPLEX_EMAIL_CONTEXT_KEYS.EMAIL_SUBJECT], []);
  const [subject] = useEmailContext(subjectSelector, 'ComplexEmailSubjectEditor');

  const sessionSelector = useCallback(store => store.userData, []);
  const [userDetails] = useSessionContext(sessionSelector);
  
  const isDesigner = checkUserAccessRoles(userDetails, ['DESIGNER', 'PUBLISHER']);

  let sideBarTabs = isCreativeDesign ? CreativeDesignTabs(t) : ComplexDesignTabs(t,CurrentDesign, isDesigner);

  const highLightIndex = sideBarTabs.findIndex(tab => tab.id === tabIndex);

  const handleResize = useCallback(() => {
    if(window.innerHeight !== activeTabPosY){
      activeTabPosition(tabIndex);
    }
  }, [activeTabPosY, tabIndex, activeTabPosition]);

  const addElementOnclick = useCallback((clickElement) => {
    updateArtboard({ [CONTEXT_KEYS.ADD_ELEMENT_TO_CREATIVE_BLOCK]: clickElement });
  }, [currentBlock]);

  const activeTabPosition = useCallback((index) => {
    let posY = 0;
    if(index !== null && index !== undefined){
      posY = index >= 0 ? document.querySelector(`#sideBar${index}`)?.getBoundingClientRect().top : 0;
    }
    console.log("change in activeTabPostion :: ", posY);
    setActiveTabPosY(posY);
  }, []);

  useEffect(() => {
    if (!hideSideBar) {
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      }
    }
  }, [handleResize, hideSideBar]);

  useEffect(() => {
    activeTabPosition(DEFAULT_TAB_INDEX);
  }, []);

  const tabClickHandler = useCallback((index) => {
    if (hideSideBar) {
      if (isCreativeDesign) {
        updateArtboard({
          [CONTEXT_KEYS.ELEMENT_SETTINGS_VISIBLE]: false,
        });
      } else {
        updateArtboard({
          [CONTEXT_KEYS.BLOCK_SETTINGS_VISIBLE]: false,
          [CONTEXT_KEYS.PAGE_LAYOUT_VISIBLE]: false,
          [CONTEXT_KEYS.ELEMENT_SETTINGS_VISIBLE]: false,
          [CONTEXT_KEYS.SWITCH_CREATIVE_DESIGN_MENU]: false,
          [CONTEXT_KEYS.CURRENT_BLOCK]: ''
        });
      }
    }
    if (index === 10) {
      updateArtboard({
        [CONTEXT_KEYS.PREVIEW_AND_DOWNLOAD]: true,
      });
    } else if (index === -1) {
      updateArtboard({
        [CONTEXT_KEYS.PREVIEW_AND_DOWNLOAD]: false,
      });
    }
    setTabIndex(oldIndex => {
      return index;
    });
    // setEnableTabExpansion(index >= 0);
  }, [hideSideBar, isCreativeDesign]);

  useEffect(() => {
    if (isCreativeDesign) {
      activeTabPosition(DEFAULT_CREATIVE_TAB_INDEX);
      tabClickHandler(DEFAULT_CREATIVE_TAB_INDEX);
      previewDownloadTab &&  tabClosePreviewDownload();
    } else {
      activeTabPosition(DEFAULT_TAB_INDEX);
      tabClickHandler(DEFAULT_TAB_INDEX);
    }
  }, [isCreativeDesign]);

  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const { state } = location;
    if(state?.tabIndex) {
      tabClickHandler(parseInt(state.tabIndex));
      setTimeout(() => {
        activeTabPosition(parseInt(state.tabIndex));
      }, 0);    
      history.replace({ tabIndex: undefined });
    }
  }, []);

  useEffect(() => {
    if (!hideSideBar) {
      document.getElementById('sidebar-absolute-close').style.visibility = 'hidden';
    } else {
      document.getElementById('sidebar-absolute-close').style.visibility = 'visible';
    }
  }, [hideSideBar]);

  const scrollToTop = useCallback(() => {
    scrollRef.current.scrollTo(0, 0);
  }, []);

  const renderElement = useCallback((elementObj, isSvg, docElementTab) => {
    return (
      <EditorElement
        element={elementObj}
        isSvg={isSvg}
        clickElement={addElementOnclick}
        toggleDragging={dummyCallback}
        pageSettings={pageSettings}
        setIsDragAndDropped={dummyCallback}
        docElementTab={docElementTab}
        isImage
      />
    )
  }, [pageSettings, addElementOnclick]);

  if (CurrentDesign === TEMPLATE_TYPE.BLOCK) {
    sideBarTabs = sideBarTabs.filter(data => data.id !== 11 && data.id !== 12 && data.id !== 15);
  }

  if(['header','footer'].includes(reusableBlockType)){
    sideBarTabs = sideBarTabs.filter(data => data.id !== 2);
  }

  useEffect(()=>{
    if(previewDownloadTab){
      activeTabPosition(10);
      tabClickHandler(10);
    }else if(!previewDownloadTab && tabIndex === 10 ){
      activeTabPosition(-1);
      tabClickHandler(-1);
    }
  },[previewDownloadTab]);

  const tabClosePreviewDownload = ()=>{
    updateArtboard({ [CONTEXT_KEYS.PREVIEW_AND_DOWNLOAD]: false });
  }

  const handleSubjectValidator = () => {
    tabClickHandler(14);
    activeTabPosition(14);
  }

  const setDefaultSidebarTab = useCallback(() => {
    activeTabPosition(DEFAULT_TAB_INDEX);
    tabClickHandler(DEFAULT_TAB_INDEX);
  }, [tabClickHandler]);

  return (
      <SidebarMenuWrapper className="mailDesign">
        <div>
        <Logo reusableTemplate={["flow", "block"].includes(CurrentDesign)}>
            <Link to={'/complexEmailTemplates'}>
              <AppLogo>
                <Icon component={DocStudioLogo} />
              </AppLogo>
            </Link>
          <div className="name">
            {t(`DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.EMAIL_TITLE.key}`, DESIGN_AREA_SIDEBAR_MENUS.EMAIL_TITLE.value)}
          </div>
          </Logo>
          <MenuTabs>
            {(!hideSideBar && tabIndex >= 0) && (
              <TabsActivityContainer>
                <TabsActivityHighlighter
                  style ={{transform : `translate3d(0px, ${activeTabPosY}px, 0px)`}}
                  tabIndex={highLightIndex}
                  isEmail>
                </TabsActivityHighlighter>
              </TabsActivityContainer>
            )}
            <TabsContainer isEmail>
              {sideBarTabs.map(tab => (
                <TabDetails
                  id={`sideBar${tab.id}`}
                  onClick={() => {
                    activeTabPosition(tab.id);
                    tabClickHandler(tab.id);
                    previewDownloadTab &&  tabClosePreviewDownload()
                  }}
                  active={tabIndex === tab.id}
                  key={tab.id}
                  isEmail
                >
                  <Tooltip placement="right" title={tab.label}>
                    <TabIcon
                      className={tabIndex === tab.id && 'activeTab'}
                      isEmail
                    >
                      <Icon
                        component={tab.icon}
                        type={tab.type}
                        className={tab.className}
                        style={{ color: '#fff' }}
                      />
                    </TabIcon>
                  </Tooltip>
                </TabDetails>
              ))}
            </TabsContainer>
            </MenuTabs>
            </div>
            <SideBarContent>
              <EmailTemplateName editable={editable} />
              <TabExpandContainer
                ref={scrollRef}
                className={!hideSideBar && tabIndex >= 0 ? 'showSideBar' : 'hideSideBar'}
                longSidebar={tabIndex === 13 || isHtmlExpanded}
                variableSidebar={tabIndex === 10}
              >
                {!hideSideBar && tabIndex >= 0 && (
                  <SidebarCloseMenu onClick={() => {
                    tabClickHandler(-1);
                    emailMethods.set({
                      [COMPLEX_EMAIL_CONTEXT_KEYS.IS_MOBILE_VIEW]: false
                    });
                  }}>
                    <Tooltip placement="right" title={t(`DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.HIDE_SIDEBAR_TOOLTIP.key}`, DESIGN_AREA_SIDEBAR_MENUS.HIDE_SIDEBAR_TOOLTIP.value)}>
                      <img src={ExitIcon} alt="exit" />
                      <Icon type="left" />
                    </Tooltip>
                  </SidebarCloseMenu>
                )}
                  {!hideSideBar && <TabMenuContainer
                    variableSidebar={tabIndex === 10 || tabIndex === 8}
                    isAccessibility= {tabIndex === 16}
                    className={tabIndex === 14 && 'fixedHeight'}
                  >
                    {tabIndex === 2 && <LetsDesignTabDetails currentDesign = {CurrentDesign}/>}
                    {tabIndex === 3 && <CreativeElementsTabDetails addElementOnclick={addElementOnclick} />}
                    {tabIndex === 5 && (
                      <UploadsTabDetails ScrollToTop={scrollToTop} renderElement={renderElement} />
                    )}
                    {tabIndex === 6 && (
                      <MasterElementsTabDetails renderElement={renderElement} isEmailTemplate={true}/>
                    )}
                    {tabIndex === 7 && <ComplexEmailFolderTab template={undefined} CurrentDesign={CurrentDesign}/>}
                    {tabIndex === 8 && <ComplexEmailMetaTab CurrentDesign={CurrentDesign}/>}
                    {tabIndex === 9 && <ComplexEmailTranslateTab />}
                    <ComplexEmailVariablesTab visible={tabIndex === 10} editable={editable} isHtmlExpanded={isHtmlExpanded} setIsHtmlExpanded={setIsHtmlExpanded} />
                    {tabIndex === 11 && <ComplexEmailTemplatesTab />}
                    {tabIndex === 12 && <ComplexEmailElementsTab />}
                    {tabIndex === 13 && <BusinessLogicTab editable={editable} />}
                    {tabIndex === 14 && <ComplexEmailSettingsTab template={undefined} CurrentDesign={CurrentDesign} />}
                    {tabIndex === 15 && <ChannelTab currentId={documentId} currentType={'email'} />}
                    {tabIndex === 16 && <ComplexDocumentAccessibilityValidator template={undefined} CurrentDesign={CurrentDesign} visible={tabIndex === 16} isEmail={true} emailSubject={subject} handleSubjectValidator={handleSubjectValidator} setDefaultSidebarTab={setDefaultSidebarTab} />}
                  </TabMenuContainer>}
              </TabExpandContainer>
              <TabExpandContainer
                id={'sidebar-absolute-container'}
                className={`sidebar-absolute ${hideSideBar ? 'showSideBar' : 'hideSideBar'}`}
              >
                <SettingsCloseButton id={'sidebar-absolute-close'} />
              </TabExpandContainer>
            </SideBarContent>
        </SidebarMenuWrapper>
  )
}

export default withTranslation(NAMESPACES)(React.memo(ComplexEmailSidebar));